import { render, staticRenderFns } from "./TaskGroupsTable.vue?vue&type=template&id=ec037ca4&"
import script from "./TaskGroupsTable.vue?vue&type=script&lang=js&"
export * from "./TaskGroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./TaskGroupsTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports